import script from "./_filter-salary.vue?vue&type=script&setup=true&lang=js"
export * from "./_filter-salary.vue?vue&type=script&setup=true&lang=js"

import "./_filter-salary.vue?vue&type=style&index=0&id=b76b2f2c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b76b2f2c"]])

export default __exports__